/** E-posta doğrulama için kayıt sonrası tanınan süre (3 gün). */
export const EMAIL_VERIFY_GRACE_MS = 3 * 24 * 60 * 60 * 1000;

export type EmailVerificationStatus = {
  /** E-posta/şifre hesabı ve henüz doğrulanmamış */
  needsVerification: boolean;
  /** 3 günlük süre doldu — panel kilitlenmeli */
  isLocked: boolean;
  /** Kalan tam gün (yukarı yuvarlanmış), süre dolmuşsa 0 */
  daysLeft: number;
  deadlineAt: number | null;
};

export function getEmailVerificationStatus(user: {
  emailVerified?: boolean;
  provider?: string | null;
  createdAt?: string | number | Date;
} | null | undefined): EmailVerificationStatus {
  if (!user) {
    return { needsVerification: false, isLocked: false, daysLeft: 0, deadlineAt: null };
  }

  if (user.emailVerified === true || user.provider) {
    return { needsVerification: false, isLocked: false, daysLeft: 0, deadlineAt: null };
  }

  const createdMs = user.createdAt ? new Date(user.createdAt).getTime() : Date.now();
  const deadlineAt = createdMs + EMAIL_VERIFY_GRACE_MS;
  const remaining = deadlineAt - Date.now();
  const isLocked = remaining <= 0;
  const daysLeft = isLocked ? 0 : Math.max(1, Math.ceil(remaining / (24 * 60 * 60 * 1000)));

  return {
    needsVerification: true,
    isLocked,
    daysLeft,
    deadlineAt,
  };
}
